exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-aside {\n  display: grid;\n  justify-items: center;\n  text-align: center;\n  grid-gap: 50px;\n  padding: 32px 39px;\n  background: var(--white);\n  border-radius: var(--main-radius);\n}\n@media only screen and (max-width: 750px) {\n.profile-aside {\n    background: var(--light-blue);\n}\n}\n.profile-aside__title {\n  font-size: 1.5rem;\n  font-weight: 500;\n  line-height: 28px;\n  text-transform: uppercase;\n}\n@media only screen and (max-width: 600px) {\n.profile-aside__title {\n    font-size: 1.25rem;\n    line-height: 24px;\n}\n}\n.profile-aside__description {\n  font-size: 1.25rem;\n  line-height: 32px;\n}\n", ""]);

// exports
